// src/routes/InventoryRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Purchase Order Components
import CreatePurchaseOrderPage from '../pages/purchaseOrder/CreatePurchaseOrderPage';
import EditPurchaseOrderPage from '../pages/purchaseOrder/EditPurchaseOrderPage';
import PurchaseOrderListPage from '../pages/purchaseOrder/PurchaseOrderListPage';
import PurchaseOrderDetailsPage from '../pages/purchaseOrder/PurchaseOrderDetailsPage';

// Stock Adjustment Components
import CreateStockAdjustmentPage from '../pages/stockAdjustment/CreateStockAdjustmentPage';
import StockAdjustmentListPage from '../pages/stockAdjustment/StockAdjustmentListPage';
import StockAdjustmentDetailsPage from '../pages/stockAdjustment/StockAdjustmentDetailsPage';

// Stock Transfer Components
import StockTransferListPage from '../pages/stockTransfer/StockTransferListPage';
import CreateStockTransferPage from '../pages/stockTransfer/CreateStockTransferPage';
import StockTransferDetailsPage from '../pages/stockTransfer/StockTransferDetailsPage';

// Warehouse Components
import ManageWarehousesPage from '../pages/inventory/ManageWarehousesPage';
import AssignWarehouseUsersPage from '../pages/inventory/AssignWarehouseUsersPage';

const InventoryRoutes = () => {
  return (
    <Routes>
      {/* Warehouse Management Page */}
      <Route 
        path="/warehouses" 
        element={
          <PermissionRoute requiredPermission="view_all_warehouses">
            <ManageWarehousesPage />
          </PermissionRoute>
        } 
      />
      <Route
        path="/warehouses/:warehouseId/assign-users"
        element={
          <PermissionRoute requiredPermission="assign_users_to_warehouse">
            <AssignWarehouseUsersPage />
          </PermissionRoute>
        }
      />

      {/* Purchase Order List */}
      <Route 
        path="/purchase-orders" 
        element={
          <PermissionRoute requiredPermission="view_all_purchase_orders">
            <PurchaseOrderListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Create Purchase Order */}
      <Route 
        path="/purchase-orders/create" 
        element={
          <PermissionRoute requiredPermission="create_purchase_order">
            <CreatePurchaseOrderPage />
          </PermissionRoute>
        } 
      />
      
      {/* Edit Purchase Order */}
      <Route 
        path="/purchase-orders/:orderId/edit" 
        element={
          <PermissionRoute requiredPermission="edit_purchase_order">
            <EditPurchaseOrderPage />
          </PermissionRoute>
        } 
      />
      
      {/* Purchase Order Details */}
      <Route 
        path="/purchase-orders/:orderId" 
        element={
          <PermissionRoute requiredPermission="view_purchase_order">
            <PurchaseOrderDetailsPage />
          </PermissionRoute>
        } 
      />

      {/* Stock Adjustment List */}
      <Route 
        path="/stock-adjustments" 
        element={
          <PermissionRoute requiredPermission="view_all_stock_adjustments">
            <StockAdjustmentListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Create Stock Adjustment */}
      <Route 
        path="/stock-adjustments/create" 
        element={
          <PermissionRoute requiredPermission="create_stock_adjustment">
            <CreateStockAdjustmentPage />
          </PermissionRoute>
        } 
      />
      
      {/* Stock Adjustment Details */}
      <Route 
        path="/stock-adjustments/:adjustmentId" 
        element={
          <PermissionRoute requiredPermission="view_stock_adjustment">
            <StockAdjustmentDetailsPage />
          </PermissionRoute>
        }
      />

      {/* Stock Transfers */}
      <Route
        path="/stock-transfers"
        element={
          <PermissionRoute requiredPermission="view_all_stock_transfers">
            <StockTransferListPage />
          </PermissionRoute>
        }
      />
      <Route
        path="/stock-transfers/create"
        element={
          <PermissionRoute requiredPermission="create_stock_transfer">
            <CreateStockTransferPage />
          </PermissionRoute>
        }
      />
      <Route
        path="/stock-transfers/:transferId/edit"
        element={
          <PermissionRoute requiredPermission="create_stock_transfer">
            <CreateStockTransferPage />
          </PermissionRoute>
        }
      />
      <Route
        path="/stock-transfers/:transferId"
        element={
          <PermissionRoute requiredPermission="view_stock_transfer">
            <StockTransferDetailsPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default InventoryRoutes;